/**
 * Global Vue configuration class
 */

import Vue from 'vue';
import App from './App.vue';
import router from "./router/router";
import VueResource from 'vue-resource';
import Router from "vue-router";
import VueSidebarMenu from 'vue-sidebar-menu';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
import VueI18n from 'vue-i18n';
import {library} from '@fortawesome/fontawesome-svg-core';
import store from "./store/store";
//VUEX
import Vuex from 'vuex';
//Material Vue
import {
    MdApp,
    MdAvatar,
    MdButton,
    MdCard,
    MdChips,
    MdContent,
    MdDialog,
    MdDialogConfirm,
    MdDivider,
    MdDrawer,
    MdField,
    MdLayout,
    MdList,
    MdMenu,
    MdProgress,
    MdRipple,
    MdTable,
    MdTabs,
    MdToolbar,
    MdTooltip
} from 'vue-material/dist/components';
import '../public/styles/vue-material.min.css';
import '../public/styles/default.css';
import {i18n} from '../public/language/i18n';
//Fontawesome
import {faDesktop} from '@fortawesome/free-solid-svg-icons/faDesktop.js';
import {faHammer} from '@fortawesome/free-solid-svg-icons/faHammer.js';
import {faArrowsAltH} from '@fortawesome/free-solid-svg-icons/faArrowsAltH.js';
import {faTachometerAlt} from '@fortawesome/free-solid-svg-icons/faTachometerAlt.js';
import {faBoxes} from '@fortawesome/free-solid-svg-icons/faBoxes.js';
import {faSignOutAlt} from '@fortawesome/free-solid-svg-icons/faSignOutAlt.js';
import {faSignInAlt} from '@fortawesome/free-solid-svg-icons/faSignInAlt.js';
import {faCog} from '@fortawesome/free-solid-svg-icons/faCog.js';
import {faUserCircle} from '@fortawesome/free-solid-svg-icons/faUserCircle.js';
import {faPlus} from '@fortawesome/free-solid-svg-icons/faPlus.js';
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight.js';
import {faTruckLoading} from '@fortawesome/free-solid-svg-icons/faTruckLoading.js';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons/faChevronLeft.js';
import {faCoffee} from '@fortawesome/free-solid-svg-icons/faCoffee.js';
import {faUserSecret} from "@fortawesome/free-solid-svg-icons/faUserSecret";
import {
    faAngleDoubleLeft,
    faBars, faBox, faBoxOpen,
    faCheck,
    faCompress,
    faCube,
    faEdit,
    faEllipsisV,
    faExclamationTriangle,
    faExpand,
    faFastBackward,
    faFastForward,
    faGlobe,
    faInfoCircle,
    faPallet,
    faPlayCircle,
    faSlidersH,
    faStepBackward,
    faStepForward,
    faTrash,
    faUndo,
    faUsersCog, faVideo, faScroll,
    faMinus,
    faDownload,
    faUpload,
    faTrashAlt,
    faKey,
    faAddressCard
} from "@fortawesome/free-solid-svg-icons";

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import VueCookies from 'vue-cookies';
import Keycloak from "keycloak-js";
import {Configs} from "./configs";
import {ClientService} from "./services/client.service";

library.add(
    faDesktop,
    faHammer,
    faArrowsAltH,
    faAngleRight,
    faUserSecret,
    faTachometerAlt,
    faBoxes,
    faSignOutAlt,
    faSignInAlt,
    faUserCircle,
    faCog,
    faPlus,
    faTruckLoading,
    faChevronLeft,
    faCoffee,
    faGlobe,
    faBars,
    faEllipsisV,
    faAngleDoubleLeft,
    faUsersCog,
    faEdit,
    faTrash,
    faPallet,
    faExclamationTriangle,
    faInfoCircle,
    faPlayCircle,
    faCube,
    faSlidersH,
    faCheck,
    faStepBackward,
    faStepForward,
    faFastBackward,
    faFastForward,
    faExpand,
    faCompress,
    faUndo,
    faBox,
    faBoxOpen,
    faVideo,
    faScroll,
    faMinus,
    faDownload,
    faUpload,
    faTrashAlt,
    faKey,
    faAddressCard
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueResource);
Vue.use(Router);
Vue.use(VueSidebarMenu);
Vue.use(VueCookies);

//Material Components
Vue.use(MdButton);
Vue.use(MdContent);
Vue.use(MdTable);
Vue.use(MdDialog);
Vue.use(MdLayout);
Vue.use(MdApp);
Vue.use(MdToolbar);
Vue.use(MdField);
Vue.use(MdList);
Vue.use(MdCard);
Vue.use(MdRipple);
Vue.use(MdMenu);
Vue.use(MdAvatar);
Vue.use(MdProgress);
Vue.use(MdTabs);
Vue.use(MdDrawer);
Vue.use(MdTooltip);
Vue.use(MdDivider);
Vue.use(MdDialogConfirm);
Vue.use(MdChips);

//Reset tokens
store.commit('RESET_TOKEN');

Configs.getInstance(async (configs: any) => {
    let initOptions = {
        url: configs.AUTH_URI,
        realm: configs.REALM,
        clientId: configs.CLIENT_ID,
        onLoad: 'login-required'
    }
    let keycloak = Keycloak(initOptions);

// @ts-ignore
    const auth: boolean = await keycloak.init({onLoad: initOptions.onLoad});
    if (!auth) {
        window.location.reload();
    } else {

        store.commit('UPDATE_TOKEN', keycloak.token);

        const client = await ClientService.loadUserFromAPI();
        store.commit('SET_USER', client);

        //commit role
        const role = await ClientService.isAdmin();
        store.commit('SET_ADMIN', role);

        new Vue({
            router,
            store,
            i18n,
            render: h => h(App, {props: {keycloak: keycloak}}),
        }).$mount('#app');
    }

    //Token Refresh
    setInterval(async () => {
        const refreshed: boolean = await keycloak.updateToken(70);
        store.commit('UPDATE_TOKEN', keycloak.token);
    }, 20)
});

